import React from 'react';
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Button,
} from '@mui/material';
import { FormattedMessage } from 'react-intl';

interface ConfirmationDialogProps {
    open: boolean;
    title: string | React.ReactNode;
    message: string | React.ReactNode;
    onConfirm: () => void;
    onCancel: () => void;
    confirmText?: string | React.ReactNode;
    cancelText?: string | React.ReactNode;
    mode?:
        | 'error'
        | 'primary'
        | 'inherit'
        | 'secondary'
        | 'success'
        | 'info'
        | 'warning';
}

const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
    open,
    title,
    message,
    onConfirm,
    onCancel,
    confirmText,
    cancelText,
    mode = 'error',
}) => {
    return (
        <Dialog
            open={open}
            onClose={onCancel}
            aria-labelledby="confirmation-dialog-title"
            aria-describedby="confirmation-dialog-description"
        >
            <DialogTitle id="confirmation-dialog-title">{title}</DialogTitle>
            <DialogContent>
                <DialogContentText id="confirmation-dialog-description">
                    {message}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onCancel} color="primary" autoFocus>
                    {cancelText || <FormattedMessage id="cancel" />}
                </Button>
                <Button onClick={onConfirm} color={mode}>
                    {confirmText || <FormattedMessage id="confirm" />}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmationDialog;
